module.exports = __webpack_public_path__ + "static/sba@2x-ded88e9db0aa21fc3ae90bd3b90f13b1.png";